import { Button } from '@simplywallst/ui-core/next';
import { useNarrativeMiniValuatorCompany } from '../hooks/useNarrativeMiniValuatorCompany';
import type { NarrativeMiniValuatorScreen } from '../utils';
import { NarrativeMiniValuatorFormEdit } from './NarrativeMiniValuatorFormEdit';
import { NarrativeMiniValuatorFormCreate } from './NarrativeMiniValuatorFormCreate';
import type { HeadingElements } from '@/utilities/heading';
type Props = {
  setScreen: (screen: NarrativeMiniValuatorScreen) => void;
  canonicalUrl: string;
  hideCompanySelect?: boolean;
  onSliderInteraction?: (isInteracting: boolean) => void;
  titleAs: HeadingElements;
};

export const NarrativeMiniValuatorValuationScreen = ({
  setScreen,
  canonicalUrl,
  hideCompanySelect,
  onSliderInteraction,
  titleAs,
}: Props) => {
  const { data } = useNarrativeMiniValuatorCompany({
    canonicalUrl,
  });
  const company = data?.Company;
  if (!company)
    return (
      <div className="grid gap-x1 px-x2">
        <p className="text-sm text-soft">No data found for this company</p>
        <Button variant="primary" onClick={() => setScreen('companySelect')}>
          Search for another company
        </Button>
      </div>
    );

  const narrative = company.myNarrative;

  if (narrative)
    return (
      <NarrativeMiniValuatorFormEdit
        setScreen={setScreen}
        company={company}
        narrative={narrative}
        hideCompanySelect={hideCompanySelect}
        onSliderInteraction={onSliderInteraction}
        titleAs={titleAs}
      />
    );

  return (
    <NarrativeMiniValuatorFormCreate
      setScreen={setScreen}
      company={company}
      hideCompanySelect={hideCompanySelect}
      onSliderInteraction={onSliderInteraction}
      titleAs={titleAs}
    />
  );
};
